/**
 * Brazilian Portuguese (pt-BR) mappings for PickStar Onboarding Page
 */

export const pickstarOnboardingPtBR = {
  // Header
  "Back to Home": "Voltar ao Início",
  "QUICK START GUIDE": "GUIA DE INÍCIO RÁPIDO",

  // Hero Section
  "Your First 2 Minutes on PickStar": "Seus Primeiros 2 Minutos no PickStar",
  "From signup to your first insight in under a minute": "Do cadastro ao seu primeiro insight em menos de um minuto",

  // Quick Stats
  "60 sec": "60 seg",
  "To first insight": "Para o primeiro insight",
  "Zero": "Zero",
  "Learning curve": "Curva de aprendizado",
  "100%": "100%",
  "AI-powered": "Potencializado por IA",
  "Free": "Grátis",
  "To start": "Para começar",

  // Introduction Section
  "Time to Value: 60 Seconds": "Tempo para Valor: 60 Segundos",
  "No setup. No learning curve. Just AI-powered sports intelligence.": "Sem configuração. Sem curva de aprendizado. Apenas inteligência esportiva com IA.",

  // Steps Section
  "5 Quick Steps to Your First Insight": "5 Passos Rápidos para Seu Primeiro Insight",

  // Step 1
  "Ask the AI Anything": "Pergunte Qualquer Coisa à IA",
  "Type any question about today's games": "Digite qualquer pergunta sobre os jogos de hoje",
  "Get instant analysis (uses StarCoins, your credits)": "Obtenha análise instantânea (usa StarCoins, seus créditos)",
  "Start asking questions": "Começar a perguntar",

  // Step 2
  "Quick Picks & xPicks": "Quick Picks e xPicks",
  "Quick Picks for Speed": "Quick Picks para Velocidade",
  "One-tap AI predictions for all games": "Previsões de IA com um toque para todos os jogos",
  "xPicks: Top 3-5 high probability bets per game (football/soccer)": "xPicks: As 3-5 melhores apostas de alta probabilidade por jogo (futebol)",
  "See confidence levels & reasoning": "Veja níveis de confiança e raciocínio",
  "Try Quick Picks": "Experimentar Quick Picks",

  // Step 3
  "Get StarCoins": "Obter StarCoins",
  "StarCoins = credits for insights": "StarCoins = créditos para insights",
  "Free to start, buy more instantly anytime": "Grátis para começar, compre mais instantaneamente a qualquer momento",

  // Step 4
  "Explore Your Way": "Explore do Seu Jeito",
  "Quick checks or deep dives": "Verificações rápidas ou análises profundas",
  "Props, matchups, trends — you decide": "Estatísticas, confrontos, tendências — você decide",
  "Explore freely": "Explorar livremente",

  // Step 5
  "Optional Pools (Beta)": "Pools Opcionais (Beta)",
  "Join free Pools to test your edge against others": "Junte-se aos Pools grátis para testar sua vantagem contra outros",
  "Beta testing": "Teste beta",

  // Step Labels
  "Step": "Passo",

  // Example Section
  "Example: Lakers Game Tonight": "Exemplo: Jogo do Lakers Hoje",
  'Ask: "What are the Lakers\' chances tonight?" → AI shows win probability, key matchups, injuries, and top plays. All in under 2 minutes.': 'Pergunte: "Quais são as chances do Lakers hoje?" → IA mostra probabilidade de vitória, confrontos principais, lesões e principais jogadas. Tudo em menos de 2 minutos.',
  "EXAMPLE": "EXEMPLO",
  "LAKERS GAME TONIGHT": "JOGO DO LAKERS HOJE",
  'USER: "What are the Lakers\' chances tonight?"': 'USUÁRIO: "Quais são as chances do Lakers hoje?"',
  "AI: WIN PROBABILITY • KEY MATCHUPS • INJURIES • TOP PLAYS": "IA: PROBABILIDADE DE VITÓRIA • CONFRONTOS PRINCIPAIS • LESÕES • PRINCIPAIS JOGADAS",
  "RESPONSE TIME: <2 MINUTES": "TEMPO DE RESPOSTA: <2 MINUTOS",

  // Additional examples
  "NFL SUNDAY PICKS": "ESCOLHAS NFL DOMINGO",
  'USER: "Give me your best NFL picks for Sunday"': 'USUÁRIO: "Me dê suas melhores escolhas da NFL para domingo"',
  "AI: TOP 3 PICKS • CONFIDENCE SCORES • KEY FACTORS • WEATHER IMPACT": "IA: TOP 3 ESCOLHAS • PONTUAÇÕES DE CONFIANÇA • FATORES-CHAVE • IMPACTO DO CLIMA",

  "PLAYER PROP ANALYSIS": "ANÁLISE DE APOSTAS EM JOGADORES",
  'USER: "Will LeBron score over 25.5 points?"': 'USUÁRIO: "LeBron marcará mais de 25.5 pontos?"',
  "AI: RECENT AVERAGES • MATCHUP HISTORY • INJURY STATUS • RECOMMENDATION": "IA: MÉDIAS RECENTES • HISTÓRICO DE CONFRONTOS • STATUS DE LESÃO • RECOMENDAÇÃO",

  // Features Section
  "Why PickStar?": "Por Que PickStar?",
  "FEATURES": "RECURSOS",
  "WHY PICKSTAR": "POR QUE PICKSTAR",
  "Natural Conversation": "Conversa Natural",
  "No slips, no jargon — just ask and get answers": "Sem bilhetes, sem jargões — apenas pergunte e obtenha respostas",
  "Sports-Focused AI": "IA Focada em Esportes",
  "Real analysis, not generic chat": "Análise real, não chat genérico",
  "Transparent Credits": "Créditos Transparentes",
  "Simple, fair StarCoins": "StarCoins simples e justos",
  "Community Insights": "Insights da Comunidade",
  "Learn from what others are asking": "Aprenda com o que outros estão perguntando",

  // FAQ Section
  "FAQ Highlights": "Destaques do FAQ",
  "FAQ HIGHLIGHTS": "DESTAQUES DO FAQ",
  "SUPPORT": "SUPORTE",
  "Do I need betting knowledge?": "Preciso de conhecimento sobre apostas?",
  "No — it's research-first.": "Não — é pesquisa em primeiro lugar.",
  "What sports are covered?": "Quais esportes são cobertos?",
  "NBA, NFL, MLB, NCAAF, Serie A, and more.": "NBA, NFL, MLB, NCAAF, Série A e mais.",
  "Can I try it free?": "Posso experimentar grátis?",
  "Yes — you get StarCoins to start.": "Sim — você recebe StarCoins para começar.",

  // CTA Section
  "Ready? Start Now": "Pronto? Comece Agora",
  "Start Researching Now": "Começar a Pesquisar Agora",
  "START RESEARCHING NOW": "COMEÇAR A PESQUISAR AGORA",
  "ACTION": "AÇÃO",
  "READY? START NOW": "PRONTO? COMECE AGORA",

  // New additions for updated design
  "BACK": "VOLTAR",
  "TO FIRST INSIGHT": "PARA PRIMEIRO INSIGHT",
  "LEARNING CURVE": "CURVA DE APRENDIZADO",
  "AI-POWERED": "POTENCIALIZADO POR IA",
  "FREE": "GRÁTIS",
  "TO START": "PARA COMEÇAR",
  "NO SETUP • NO LEARNING CURVE • JUST AI-POWERED SPORTS INTELLIGENCE": "SEM CONFIGURAÇÃO • SEM CURVA DE APRENDIZADO • APENAS INTELIGÊNCIA ESPORTIVA COM IA",
  "START ASKING": "COMEÇAR A PERGUNTAR",
  "TRY QUICKPICKS": "TENTAR QUICKPICKS",
  "GET STARCOINS": "OBTER STARCOINS",
  "EXPLORE": "EXPLORAR",
  "BETA": "BETA",
  "NATURAL CONVERSATION": "CONVERSA NATURAL",
  "SPORTS-FOCUSED AI": "IA FOCADA EM ESPORTES",
  "TRANSPARENT CREDITS": "CRÉDITOS TRANSPARENTES",
  "COMMUNITY INSIGHTS": "INSIGHTS DA COMUNIDADE",
  "Do I need to know about betting to use PickStar?": "Preciso saber sobre apostas para usar o PickStar?",
  "No — it's research-first.": "Não — é pesquisa em primeiro lugar.",
  "How do StarCoins work?": "Como funcionam os StarCoins?",
  "StarCoins are credits you use to ask questions and get Quick Picks. Think of them like tokens at an arcade — they power your experience.": "StarCoins são créditos que você usa para fazer perguntas e obter Quick Picks. Pense neles como fichas em um fliperama — eles alimentam sua experiência.",
  "What sports does PickStar cover?": "Quais esportes o PickStar cobre?",
  "Can I try it for free?": "Posso experimentar grátis?",
  "Yes — you get StarCoins to start.": "Sim — você recebe StarCoins para começar."
};